import type { ResourceProps } from 'react-admin';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import OrderList from './OrderList';

const ordersResource: Omit<ResourceProps, 'children'> = {
  name: 'orders',
  list: OrderList,
  icon: ReceiptLongIcon,
  options: { label: 'Orders' },
};

export default ordersResource;
export { ordersDataProvider } from './dataProvider';
export type { OrderRecord } from './types';
